exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4500afbc!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/user/ConfigRoles.vue
// module id = 586
// module chunks = 2